import { sendGTMEvent } from '@next/third-parties/google'

// Page-lifetime dedupe set shared across every Braze lead-capture path: the
// iframe submit listener in hooks/useBraze.ts and the postMessage handler in
// components/ClientPortal.tsx. Both can fire for a single modal submission —
// the listener catches the in-iframe form submit while the modal's own HTML
// posts back to the parent — so without this GA4 would record two
// generate_lead events for one lead. Mirrors the POST dedupe in
// hooks/useCreateWelcomeLead.ts.
const trackedLeads = new Set<string>()

// Test-only helper: clears the dedupe set so each test starts fresh.
// Production code should not call this — it would defeat the dedupe.
export const _resetTrackedLeadsForTesting = (): void => {
  trackedLeads.clear()
}

/**
 * Pushes the GA4 recommended `generate_lead` event for a captured lead, at most
 * once per email per page lifetime.
 *
 * Both Braze submit paths call this. Previously only the postMessage path
 * pushed to GTM, so any campaign whose custom HTML does not post back to the
 * parent captured the lead (Braze event + welcome-lead POST) without ever
 * emitting the GTM event.
 */
export const trackGenerateLead = (email: string, method: string): void => {
  const trimmed = email.trim()
  if (!trimmed || trackedLeads.has(trimmed)) return
  trackedLeads.add(trimmed)

  sendGTMEvent({
    event: 'generate_lead',
    method,
    user_email: trimmed,
  })
}
